import { Grid } from "@material-ui/core";
import { Button } from "@material-ui/core";
import { Theme, makeStyles } from "@material-ui/core";
import DeleteIcon from "@material-ui/icons/Delete";
import EditIcon from "@material-ui/icons/Edit";
import FormatListBulletedSharpIcon from "@material-ui/icons/FormatListBulletedSharp";
import { ColDef, EditableCallbackParams } from "ag-grid-community";
import moment from "moment";
import React, { useState } from "react";
import { useShiftsCrewsContext } from "../../context/ShiftsCrewsContext";
import { ShiftParameters } from "../../models/ShiftParameters";

const useStyles = makeStyles((theme: Theme) => ({
	root: {},
}));

type Props = {
	setOpenModalEditShift: Function;
	setOpenModalDeleteShift: Function;
	showContextMenu: Function;
};

export const useTableData = ({
	setOpenModalEditShift,
	setOpenModalDeleteShift,
	showContextMenu,
}: Props) => {
	const { state, actions } = useShiftsCrewsContext();
	const classes = useStyles();

	const rows = state.shifts?.map(
		({
			PatternStart,
			ShiftCodes,
			Crews,
			PatternDays,
			CrewRotation,
			Comments,
			CanEdit,
		}: ShiftParameters) => ({
			id: ShiftCodes,
			PatternStart,
			ShiftCodes,
			Crews,
			PatternDays,
			CrewRotation,
			Comments,
			CanEdit,
		}),
	);
	const columnDefs: ColDef[] = [
		{
			field: "PatternStart",
			headerName: "Pattern Start",
			valueFormatter: ({ value }: { value: any }) =>
				`${moment(value).format("L")}, ${moment(value).format("LTS")}`,
			minWidth: 180,
			flex: 4,
			cellStyle: {
				display: "flex",
				alignItems: "center",
				justifyContent: "center",
			},
		},
		{
			field: "ShiftCodes",
			headerName: "Shift Codes",
			minWidth: 150,
			flex: 2,
			cellStyle: {
				display: "flex",
				alignItems: "center",
				justifyContent: "center",
			},
		},
		{
			field: "Crews",
			headerName: "Crews",
			minWidth: 150,
			flex: 2,
			cellStyle: {
				display: "flex",
				alignItems: "center",
				justifyContent: "center",
			},
		},
		{
			sortable: false,
			field: "PatternDays",
			headerName: "Shifts",
			minWidth: 130,
			flex: 1,
			cellStyle: {
				display: "flex",
				alignItems: "center",
				justifyContent: "center",
			},
		},
		{
			cellRenderer: (params: EditableCallbackParams) => {
				return (
					<Grid
						container
						style={{
							height: "100%",
							display: "flex",
							justifyContent: "center",
							alignItems: "center",
						}}
						className={classes.root}
					>
						<Grid
							item
							xs={12}
							md={12}
							style={{
								display: "flex",
								justifyContent: "center",
								alignItems: "center",
							}}
						>
							<Button
								size="small"
								style={{ minWidth: 36, padding: 4 }}
								onClick={() => {
									(async () => {
										actions.setShiftTableData(params?.data as ShiftParameters);
										setOpenModalEditShift(true);
									})();
								}}
							>
								<EditIcon color="primary" fontSize="small" />
							</Button>
							<Button
								size="small"
								style={{ minWidth: 36, padding: 4 }}
								onClick={() => {
									(async () => {
										actions.setShiftTableData(params?.data as ShiftParameters);
										setOpenModalDeleteShift(true);
									})();
								}}
							>
								<DeleteIcon color="secondary" fontSize="small" />
							</Button>
							<Button
								size="small"
								style={{ minWidth: 36, padding: 4 }}
								onClick={(e) => showContextMenu(e, params.data, "TableShifts")}
							>
								<FormatListBulletedSharpIcon color="action" fontSize="small" />
							</Button>
						</Grid>
					</Grid>
				);
			},
			field: "",
			flex: 3,
			minWidth: 240,
			editable: false,
			autoHeight: false,
			suppressNavigable: true,
		},
	];

	return { rows, columnDefs };
};
